export default __webpack_public_path__ + "static/article4-725763105bcf36d2cab5e0c4048675bf.png";